// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip-note{width:100%!important;text-align:right!important;font-size:12px!important;margin-top:10px}.list-style{font-size:18px;line-height:28px;list-style-type:disc;color:#000;font-weight:600;position:relative}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
